import { render, staticRenderFns } from "./DeliverablePreview.vue?vue&type=template&id=6e11d670&"
import script from "./DeliverablePreview.vue?vue&type=script&lang=js&"
export * from "./DeliverablePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports